import { Row } from '@scaleaq/scaleui';
import { stroke } from '@scaleaq/sui-tokens/colors/stroke';
import { styled } from 'styled-components';

export const StyledRow = styled(Row)<{ $withPointerCursor?: boolean }>`
  cursor: ${({ $withPointerCursor }) => ($withPointerCursor ? 'pointer' : 'default')};
  &:hover {
    background-color: ${({ $withPointerCursor }) =>
      $withPointerCursor ? stroke.neutral.soft[100] : 'inherit'};
  }
`;
